export default __webpack_public_path__ + "static/media/08edde9d-c27b-4731-a27f-d6cd9b01cd06.189fb735.woff";